// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{height:100%}ul{padding-left:0;display:inline-flex}li{padding:20px;font-size:18px;white-space:nowrap}li a{color:#777}li a:hover{color:#000}li .selected{color:#000;border-color:#000;border-bottom-style:solid;padding-bottom:8px;font-weight:bold}ul{list-style-type:none}", ""]);
// Exports
module.exports = exports;
